import { useState } from 'react';

const useMiViewMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action?: Function) => {
    handleClose();
    if (action) action();
  };

  return {
    handleClick,
    handleClose,
    handleAction,
    open,
    anchorEl,
  };
};

export default useMiViewMenu;
